import templateUrl from './summary.html';
import sweetAlert from 'angular-sweetalert';
import sweetAlertCss from 'sweetalert/lib/sweet-alert.css';

export default angular.module('eventix.dashboard.wizard.simple.summary', ['oitozero.ngSweetAlert'])
    .config(ModuleConfig)
    .component('wizardSimpleSummary', {
        controller: WizardSimpleSummaryController,
        templateUrl: templateUrl,
        bindings: {
            event: '<',
            company: '<'
        }
    }).name;

function ModuleConfig($stateProvider) {
    $stateProvider.state('eventix.dashboard.wizard.simple.summary', {
        url: '/summary',
        component: 'wizardSimpleSummary',
        bindings: {
            event: 'currentEvent',
            company: 'company'
        }
    });
}

function WizardSimpleSummaryController($q, $scope, $state, $uibModal, $translate, LaravelValidationRules, SweetAlert, ErrorRejector, EventLocation, SimpleTicket, ScannerType, Tracker) {
    const $ctrl = this;

    $ctrl.inShop = inShop;
    $ctrl.listRules = listRules;
    $ctrl.inScanner = inScanner;
    $ctrl.openIntegrationModal = openIntegrationModal;

    $ctrl.dates = null;
    $ctrl.location = null;

    $ctrl.$postLink = function() {
        $ctrl.hasBankDetails = $ctrl.company.bank_account_number && $ctrl.company.bank_account_name;

        loadData();

        let oneHourAgo = moment().subtract(1, 'hour');
        let recent = moment($ctrl.event.created_at, 'YYYY-MM-DDTHH:mm:ssZ').isAfter(oneHourAgo);

        if (recent) {
            SweetAlert.swal({
                title: $translate.instant('common.notice.congratulations'),
                text: $translate.instant('common.notice.readyToSell'),
                type: 'success',
                timer: 1500,
                showConfirmButton: false
            });
        }
    };

    function inShop(ticket) {
        return !_.isNil( _.find($ctrl.shops, shop => _.find(shop.tickets, {guid: ticket.guid})));
    }

    function listRules(meta) {
        if (!meta) {
            return '';
        }

        return _.map(LaravelValidationRules.parse(meta.extra), r => LaravelValidationRules[r.name].label).join(', ');
    }

    function inScanner(ticket) {
        return !_.isNil(_.find($ctrl.scanners, scanner => _.find(scanner.products, {guid: ticket.guid})));
    }

    // This method results in a VERY BIG amount of calls...
    // Right now only made it (slightly) more efficient and a LOT more readable!
    // A big update would require a custom API endpoint (Seed Event could be used!!!)
    function loadData() {
        return $q.all([
            loadEvent(),
            loadTickets(),
            loadShops(),
            loadScannerTypes()
        ]);
    }

    function loadEvent() {
        return $ctrl.event.$queryEventDate()
            .then(eventDates => {
                $ctrl.dates = {
                    start: _.min(_.map(eventDates, 'start')),
                    end: _.max(_.map(eventDates, 'end')),
                    capacity: _.join(_.filter(_.map(eventDates, 'capacity')), ', '),
                };
            })
            .then(() => $ctrl.event.$getLocation())
            .then(location => $ctrl.location = location)
            .then(() => $ctrl.event)
            .catch(ErrorRejector.handle);
    }

    function loadTickets() {
        return $ctrl.event.$queryTicket()
            .then(tickets => $q.all(_.map(tickets, ticket => {
                return ticket.$hasCustomTemplate()
                    .then(has => ticket.hasCustomTemplate = has)
                    .then(() => ticket);
            })))
            .then(tickets => $ctrl.tickets = tickets)
            .catch(ErrorRejector.handle);
    }

    function loadShops() {
        Tracker.configureApi(_.trimEnd(SHORTIE_API_ROOT, '/')+'/trackers/:guid');
        let shopsPromises = [
            $ctrl.event.$queryShop(),
            $ctrl.company.$getOrCreateShop().then(shop => [shop]),
        ];

        return $q.all(shopsPromises)
            .then(results => _.unionBy(results[0], results[1], 'guid'))
            .then(shops => $q.all(_.map(shops, shop => {
                return $q.all([
                    shop.$queryMetaData().then(metaData => shop.metaData = metaData),
                    shop.$queryTicket().then(tickets => shop.tickets = tickets),
                    shop.$getOrCreatePrimaryTracker().catch(angular.noop)
                ]).then(() => shop);
            })))
            .then(shops => $ctrl.shops = shops)
            .catch(ErrorRejector.handle);
    }

    function loadScannerTypes() {
        return $ctrl.event.$queryOrCreateScannerType(() => ScannerType.newDefault([$ctrl.event.name, $translate.instant('models.models.scannerType', {count: 1})].join(' - ')))
            .then(scannerTypes => $q.all(_.map(scannerTypes, scannerType => {
                return scannerType.$queryProduct()
                    .then(products => scannerType.products = products)
                    .then(() => scannerType);
            })))
            .then(scannerTypes => $ctrl.scanners = scannerTypes)
            .catch(ErrorRejector.handle);
    }

    function openIntegrationModal(shop) {
        $uibModal.open({
            component: 'shopIntegrationModal',
            resolve: {
                shop: function() {
                    return shop;
                }
            }
        });
    }
}

